module.exports = __webpack_public_path__ + "static/img/1.c447927.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.jpg
// module id = tGse
// module chunks = 1